import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Sahityik Sanskritik Parishad</h1>
                <p>Home &gt; Sahityik Sanskritik Parishad</p>
            </div>
        </div>
    )
}

export default Hero;